import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-header border-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Logs")
], -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  type: "button",
  class: "btn btn-sm btn-light-primary"
}
const _hoisted_5 = { class: "svg-icon svg-icon-3" }
const _hoisted_6 = { class: "card-body py-0" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = {
  class: "table align-middle table-row-dashed fw-bold text-gray-600 fs-6 gy-5",
  id: "kt_table_customers_logs"
}
const _hoisted_9 = { class: "min-w-70px" }
const _hoisted_10 = { class: "pe-0 text-end min-w-200px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`card pt-4 ${_ctx.cardClasses}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/files/fil021.svg" })
          ]),
          _createTextVNode(" Download Report ")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("table", _hoisted_8, [
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logs, (log, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", _hoisted_9, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`badge badge-light-${log.color}`)
                  }, _toDisplayString(log.code), 3)
                ]),
                _createElementVNode("td", null, _toDisplayString(log.message), 1),
                _createElementVNode("td", _hoisted_10, _toDisplayString(log.date), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 2))
}